module.exports = __webpack_public_path__ + "static/media/safari.6daa972b.png";